class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.initialize();

    window.addEventListener('resize', debounce(() => {
      this.slider.destroy();
      this.initialize();
    }, 200));
  }

  initialize() {
    let options = {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 6
    };

    if (matchMedia("(max-width: 1024px)").matches) {
      options.groupCells = 4;
      options.dragThreshold = 10;
    }

    if (matchMedia("(max-width: 767px)").matches) {
      options.groupCells = 2;
    }

    this.slider = new Flickity(this, options);
  }
}

customElements.define("collection-slider", CollectionSlider);
